import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  FaFutbol,
  FaShieldAlt,
  FaInfoCircle,
  FaRegCopyright,
} from 'react-icons/fa';
import { GiMeditation } from 'react-icons/gi';

export const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="mt-auto py-8 px-4 sm:px-6 lg:px-8 text-white bg-gradient-to-r from-slate-900 to-indigo-900 shadow-2xl border-t border-indigo-800">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Logo and Brand Section */}
        <div className="flex flex-col items-center md:items-start space-y-4">
          <div className="flex items-center gap-2">
            <GiMeditation className="text-3xl text-teal-400" />
            <span className="text-xl font-bold">
              BetZen<span className="text-teal-400">.app</span>
            </span>
          </div>
          <p className="text-sm text-gray-300 text-center md:text-left">
            {t('footer.description')}
          </p>
          <p className="text-xs text-gray-400 flex items-center">
            <FaRegCopyright className="mr-1" />
            BetZen.app {new Date().getFullYear()} |{' '}
            {t('footer.allRightsReserved')}
          </p>
        </div>

        {/* Legal Links */}
        <div className="flex flex-col items-center md:items-start space-y-4">
          <h4 className="font-bold text-lg flex items-center mb-2">
            <FaShieldAlt className="mr-2 text-teal-400" />
            {t('footer.legalInformation')}
          </h4>
          <div className="flex flex-col space-y-2">
            <Link
              to="/cookie-policy"
              className="text-gray-300 hover:text-teal-400 transition-colors flex items-center"
            >
              <span className="h-1 w-1 rounded-full bg-teal-400 mr-2 inline-block"></span>
              {t('footer.cookiePolicy')}
            </Link>
            <Link
              to="/privacy-policy"
              className="text-gray-300 hover:text-teal-400 transition-colors flex items-center"
            >
              <span className="h-1 w-1 rounded-full bg-teal-400 mr-2 inline-block"></span>
              {t('footer.privacyPolicy')}
            </Link>
            <Link
              to="/terms"
              className="text-gray-300 hover:text-teal-400 transition-colors flex items-center"
            >
              <span className="h-1 w-1 rounded-full bg-teal-400 mr-2 inline-block"></span>
              {t('footer.termsOfUse')}
            </Link>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="flex flex-col items-center md:items-start space-y-4">
          <h4 className="font-bold text-lg flex items-center mb-2">
            <FaInfoCircle className="mr-2 text-teal-400" />
            {t('footer.disclaimer')}
          </h4>

          <p className="text-sm text-gray-300 text-left">
            {t('footer.disclaimerText')}
          </p>
        </div>
      </div>
    </footer>
  );
};
